<template>
  <div class="page-wrap">

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header__icon"><i class="fa fa-star"></i></div>
        <div class="panel-header__text">
          <div class="panel-header__title">Featured</div>
          <div class="panel-header__sub">Drag rows to reorder featured services</div>
        </div>
        <div class="panel-header__action" v-if="featureds.length > 0">
          <button class="btn-update" ref="kt_update_note" @click="storeUpdate">
            <i class="fa fa-save"></i> Update
          </button>
        </div>
      </div>

      <!-- Loading -->
      <div class="tbl-loading" v-if="loadingData">
        <div class="tbl-loading__spinner"></div>
        <span>Loading featured items…</span>
      </div>

      <!-- Table -->
      <div class="table-wrap" v-if="!loadingData">
        <table class="feat-table">
          <thead>
            <tr>
              <th class="th-drag"></th>
              <th class="th-num">#</th>
              <th>Service Name</th>
              <th>Type</th>
            </tr>
          </thead>
          <draggable v-model="featureds" tag="tbody" handle=".drag-handle">
            <tr v-for="(item, index) in featureds" :key="item.name" class="feat-row">
              <td class="td-drag">
                <i class="fa fa-grip-vertical drag-handle"></i>
              </td>
              <td class="td-num">{{ index + 1 }}</td>
              <td class="td-name">{{ item.object_detail.name }}</td>
              <td>
                <span class="type-badge">{{ item.feature_type }}</span>
              </td>
            </tr>
          </draggable>
        </table>

        <!-- Empty state -->
        <div class="empty-state" v-if="featureds.length === 0">
          <i class="fa fa-star empty-state__icon"></i>
          <div class="empty-state__title">No featured items</div>
          <div class="empty-state__sub">Featured services will appear here</div>
        </div>
      </div>

    </div>

    <!-- Floating save bar -->
    <div class="save-bar" v-if="featureds.length > 0">
      <span class="save-bar__hint">
        <i class="fa fa-info-circle"></i> Drag rows to change display order
      </span>
      <button class="save-bar__update" ref="kt_update_note_bar" @click="storeUpdate">
        <i class="fa fa-save"></i> Update Order
      </button>
    </div>

  </div>
</template>

<script>
import { FEATUREDUPDATE, FEATURED } from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";

export default {
  computed: {
    ...mapGetters(["currentUser", "getBServices"])
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.dispatch(FEATURED).then(res => {
      this.featureds = res.data;
    });
  },
  components: { draggable },
  methods: {
    storeUpdate() {
      this.$store
        .dispatch(FEATUREDUPDATE, [...this.featureds])
        .then(() => {
          this.$toastr.s("Order updated successfully");
          this.$store.dispatch(FEATURED).then(res => {
            this.featureds = res.services;
          });
        })
        .catch(() => {
          this.$toastr.e("Something went wrong");
        });
    }
  },
  data() {
    return {
      loadingData: false,
      featureds: [],
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Featured",  route: "" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$border: #dde2ec;

@keyframes spin { to { transform: rotate(360deg); } }

.page-wrap {
  padding: 12px 12px 80px;
  font-family: $font;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    flex-shrink: 0;
  }

  &__text { flex: 1; }
  &__title { font-size: 16px; font-weight: 700; color: $dark; line-height: 1.2; }
  &__sub   { font-size: 12px; color: #7a8499; margin-top: 3px; }
  &__action { flex-shrink: 0; }
}

.btn-update {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: $blue;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: background 0.15s, box-shadow 0.15s;
  &:hover { background: #2d85bb; box-shadow: 0 4px 12px rgba(56,154,212,0.3); }
}

/* ── loading ── */
.tbl-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 28px 24px;
  font-size: 13px;
  color: #7a8499;

  &__spinner {
    width: 18px;
    height: 18px;
    border: 2.5px solid #c5d8f5;
    border-top-color: $blue;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
    flex-shrink: 0;
  }
}

/* ── table ── */
.table-wrap {
  padding: 0 24px 24px;
  overflow-x: auto;
}

.feat-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: $dark;

  th {
    padding: 10px 14px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #7a8499;
    border-bottom: 2px solid $border;
    white-space: nowrap;
    background: #fafbfd;
  }

  .th-drag { width: 36px; }
  .th-num  { width: 44px; text-align: center; }

  td {
    padding: 12px 14px;
    border-bottom: 1px solid #f0f2f8;
    vertical-align: middle;
  }

  .feat-row {
    transition: background 0.12s;
    &:hover { background: #f8fbff; }
    &:last-child td { border-bottom: none; }
  }

  .td-drag { text-align: center; }
  .td-num  { text-align: center; color: #a0aab8; font-size: 12px; }
  .td-name { font-weight: 400; }
}

/* ── drag handle ── */
.drag-handle {
  color: #c5d0e0;
  cursor: grab;
  font-size: 13px;
  padding: 4px;
  &:active { cursor: grabbing; }
}

/* ── type badge ── */
.type-badge {
  display: inline-block;
  padding: 3px 10px;
  background: rgba(56,154,212,0.1);
  color: $blue;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
}

/* ── empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px;
  gap: 10px;

  &__icon  { font-size: 38px; color: #c5d0e0; }
  &__title { font-size: 15px; font-weight: 600; color: $dark; }
  &__sub   { font-size: 13px; color: #7a8499; }
}

/* ── floating save bar ── */
.save-bar {
  position: fixed;
  bottom: 2.5rem;
  width: calc(78vw);
  left: 50%;
  transform: translateX(-40%);
  background: #1a2340;
  border-radius: 14px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 8px 32px rgba(13,27,62,0.3);
  z-index: 100;

  &__hint {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 12px;
    color: rgba(255,255,255,0.55);
    i { font-size: 12px; }
  }

  &__update {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: $blue;
    color: #fff;
    border: none;
    border-radius: 9px;
    padding: 9px 22px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s, box-shadow 0.15s;
    &:hover { background: #2d85bb; box-shadow: 0 4px 14px rgba(56,154,212,0.4); }
  }
}
</style>
